<template>
  <div class="user-wrap">
    <div class="cover-wrap">
      <img class="user-cover" :src=" '/static/images/f.jpg'" alt="">
    </div>
    <ul class="user-info">
      <li class="name">{{info.username}} <span  v-if="info.nickname">({{info.nickname}})</span> </li>
      <li class="ignore">
        用户类型：<span v-if="info.account_type==1"> 信用</span><span v-if="info.account_type==2"> 现金</span>
      </li>
      <li class="ignore">
        盘口切换：
        <select v-model="info.market_default" @change="getmarket">
          <option
          v-for="(item,index) in info.market"
          :key="index"
          :label="item"
          :value="item">{{item}}</option>
        </select>
      </li>
      <li class="ignore">
        信用总额：<span class="m">{{info.credit_limit}}</span>
      </li>
      <li class="ignore">
        信用余额：<span class="m">{{info.credit_balance}}</span>
      </li>
    
      <li class="ignore">
        未结算（冻结）金额：<span class="m">{{info.un_settle_sum||0}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { changeMarket } from "@/service/user";
  export default {
    name: "user-wrap",
    props: {
      info: {
        type: Object,
        default () {
          return {
            cover: '',
            nickname: '666',
            username: '666',
            markert: 'A盘',
            un_settle_sum: 1000000,
            credit_balance: 1000000,
            credit_limit: 5,
            e: 0
          }
        }
      },
    },
    filters: {
      formatMarket: function (value) {
        return value.join(",");
      }
    },
    methods: {
      async getmarket(rows) {
        const info = await changeMarket({
          market: this.info.market_default
        });
      },
    }
  }
</script>

<style scoped lang="less">
  .user-wrap{
    margin: 15px 10px;
    display: flex;
    background: #fff;
    border-top: 1px solid #DCDCDC;
    .cover-wrap{
      width: 160px;
      text-align: center;
      border-right: 1px solid #e9e9e9;
      img.user-cover{
        width: 120px;
        height: 120px;
        margin: 60px auto;
        display: block;
        border-radius: 60px;
        background-color: #3bb4f2;
      }
    }
    .user-info{
      flex: 1;
      >li{
        color: #c1c1c1;
        height: 64px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        >span{
          color: #f60;
        }
        >.m:before{
          content: "￥";
        }
      }
      .ignore{
        font-size: 13px;
      }
      >li~li{
        border-top: 1px solid #e9e9e9;
      }
      >.name{
        color: #666;
        font-size: 32px;
        font-weight: bold;
        >span{
          color: #3f3f3f;
          font-size: 20px;
          font-weight: normal;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user-info/index.vue